import { AppInventoryOption } from '@openx/types/targeting/appInventory.ts';
import { TargetingFields } from '@openx/types/targeting/targeting.ts';

export const useIsAppInventoryV2Enabled = observableTargeting => {
  const isOldInventory =
    Boolean(observableTargeting[TargetingFields.INVENTORY_AND_CONTENT]?.[AppInventoryOption.APP_BUNDLE_ID]) ||
    Boolean(observableTargeting[TargetingFields.INVENTORY_AND_CONTENT]?.[AppInventoryOption.APP_GROUP]);

  return !isOldInventory;
};
